
// Import global utils
import { isDefined } from '@automator/shared/utils/is-defined';

// Import recipe builder services
import { updateFilters } from '@automator/builder/services/item/filter';

// Import utilities
import { sanitizeConditionsForMeta } from '@automator/builder/_legacy/js/item/conditions/utilities';

/**
 * Updates the conditions saved in the recipe meta
 *
 * @param {Object}   options           The options
 * @param {Callback} options.onSuccess The callback invoked if the task is successful
 * @param {Callback} options.onFail    The callback invoked if the task is not successful
 * @return {undefined}
 */
const updateRemoteConditionsMeta = ( { onSuccess, onFail } ) => {
	// Update only if Pro is active
	if ( ! UncannyAutomatorBackend._site.automator.is_pro_active ) {
		return;
	}

	// Get conditions
	const conditions = sanitizeConditionsForMeta();

	updateFilters(
		JSON.stringify( conditions )
	).then( response => {
		// Check if the task was successful
		if ( ! response.success ) {
			return;
		}

		// Check if the onSuccess callback is defined
		if ( isDefined( onSuccess ) ) {
			try {
				// Clear the cache of tokens
				UncannyAutomator._cache.tokens = [];
				
				// Invoke onSuccess callback
				onSuccess( response );
			} catch ( e ) {
				if ( UncannyAutomator._site.has_debug_enabled ) {
					// eslint-disable-next-line no-console
					console.error( "updateRemoteConditionsMeta: Couldn't execute the onSuccess callback." );

					// eslint-disable-next-line no-console
					console.error( e );
				}
			}
		}
	} ).catch( error => {
		if ( UncannyAutomator._site.has_debug_enabled ) {
			// eslint-disable-next-line no-console
			console.error(
				"updateRemoteConditionsMeta: Couldn't update remote conditions meta. UI might be outdated."
			);
		}

		// Check if the onFail callback is defined
		if ( isDefined( onFail ) ) {
			try {
				// Invoke onFail callback
				onFail();
			} catch ( e ) {
				if ( UncannyAutomator._site.has_debug_enabled ) {
					// eslint-disable-next-line no-console
					console.error( "updateRemoteConditionsMeta: Couldn't execute the onFail callback." );

					// eslint-disable-next-line no-console
					console.error( e );
				}
			}
		}
	} );
};

export default updateRemoteConditionsMeta;
